import React from 'react';

const VSISELogo = ({ height = 40, style = {} }) => {
  return (
    <div className="flex items-center justify-center p-2">
      <img
        src={process.env.PUBLIC_URL + '/v-SISE-Logo-Mayo.png'}
        alt="Logo vSISE"
        style={{ 
          height: `${height}px`, 
          width: 'auto',
          objectFit: 'contain', 
          ...style 
        }}
        className="dark:brightness-110"
      />
    </div>
  );
};

export default VSISELogo;
